import { PENGATURAN_SIMPANAN_BERJANGKA} from "../../constants/admin/masterdata/constants";

const initialState = {
  data: {},
  loadingData: false,
  loadingUpdate: false,
  updateSuccess: false,
};

export const simpananBerjangkaReducer = (state = initialState, action) => {
  switch (action.type) {
    case PENGATURAN_SIMPANAN_BERJANGKA.LOADING_DATA_PENGATURAN_BERJANGKA_SUCCESS:
      return { ...state, loadingData: action.load };

    case PENGATURAN_SIMPANAN_BERJANGKA.GET_DATA_PENGATURAN_BERJANGKA_SUCCESS:
      return {
        ...state,
        data: action.data ?? {},
      };

    case PENGATURAN_SIMPANAN_BERJANGKA.LOADING_ACTION_PENGATURAN_BERJANGKA:
      return { ...state, loadingUpdate: action.load };

    case PENGATURAN_SIMPANAN_BERJANGKA.UPDATE_BERJANGKA_SUCCESS:
      return { ...state, updateSuccess: true };

    case PENGATURAN_SIMPANAN_BERJANGKA.UPDATE_BERJANGKA_RESET:
      return { ...state, updateSuccess: false };

    default:
      return state;
  }
};
